import React from 'react'
import Notifications from '../components/notification/Notifications'

export default function Notification() {
  return (
    <div>
        <Notifications/>
    </div>
  )
}